import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const TiltBook = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [12, -12]), { stiffness: 120, damping: 14 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-16, 16]), { stiffness: 120, damping: 14 });
  const glareX = useTransform(mx, [-0.5, 0.5], ["0%", "100%"]);

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const onLeave = () => { mx.set(0); my.set(0); };

  return (
    <div onMouseMove={onMove} onMouseLeave={onLeave} className="relative [perspective:1200px]" data-testid="hero-book">
      <motion.div
        initial={{ opacity: 0, y: 60, rotateZ: -6 }}
        animate={{ opacity: 1, y: 0, rotateZ: -3 }}
        transition={{ duration: 1.3, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        style={{ rotateX: rx, rotateY: ry, transformStyle: "preserve-3d" }}
        className="relative mx-auto w-[78%] max-w-[420px] aspect-square"
      >
        <div className="absolute inset-0 translate-x-4 translate-y-5 rounded-r-2xl rounded-l-md bg-black/40 blur-2xl" />
        <div className="absolute inset-0 rounded-r-2xl rounded-l-md overflow-hidden ring-1 ring-black/10 shadow-[inset_10px_0_14px_-8px_rgba(0,0,0,0.35)]">
          <img src="/img/book-cover.jpg" alt="The Party Pet Shop book cover by Reuben Ackerman" className="w-full h-full object-cover" />
          <div className="absolute inset-y-0 left-0 w-4 bg-gradient-to-r from-black/30 to-transparent" />
          <motion.div
            style={{ left: glareX }}
            className="absolute -inset-y-10 w-1/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-white/35 to-transparent rotate-12 pointer-events-none"
          />
        </div>
        <motion.div
          style={{ translateZ: 60 }}
          className="absolute -top-5 -right-5 sm:-top-7 sm:-right-7 w-24 h-24 sm:w-28 sm:h-28 rounded-full bg-coral text-cream grid place-items-center text-center font-display leading-none rotate-12 shadow-xl"
        >
          <span className="text-sm sm:text-base">Only<br /><span className="text-3xl sm:text-4xl">£6</span></span>
        </motion.div>
      </motion.div>
    </div>
  );
};
